import actions from "@/store/sponsor/actions";
import state from "@/store/sponsor/states";
import mutations from "@/store/sponsor/mutations";

const SponsorModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default SponsorModule;